import { MdCheckCircle } from "react-icons/md"

import GestaoVagaCidadeDistancia from "./GestaoVagaCidadeDistancia.jsx"
import {
	formatarMetrosCurto,
	resolverMotivoTipo,
	textoDistanciaVagaFila,
} from "./gestaoVagaFilaUi.js"

/**
 * Cidade + status de raio: fora do raio mostra distância; dentro mostra só confirmação.
 */
export default function GestaoVagaFilaRaioStatus({
	vaga,
	className = "",
	onAtualizarLocalizacao,
	atualizandoGeo = false,
	carregando = false,
}) {
	if (!vaga) return null

	const dentro = Boolean(vaga.dentroRaioFila)
	const semGeo = resolverMotivoTipo(vaga) === "sem_geo"
	const distancia = textoDistanciaVagaFila(vaga)
	const cidade = String(vaga.cidadeEstado || "").trim()
	const limiteRaio = formatarMetrosCurto(vaga.raioFilaMetros)

	if (semGeo) {
		return cidade ? (
			<p className={`gv-fila-cidade-só m-0 mb-2 ${className}`.trim()}>{cidade}</p>
		) : null
	}

	if (dentro) {
		return (
			<div className={`gv-fila-raio-ok mb-2 ${className}`.trim()}>
				{cidade ? <p className="gv-fila-cidade-só m-0 mb-1">{cidade}</p> : null}
				<p className="gv-fila-raio-ok__linha m-0" role="status">
					<MdCheckCircle size={18} aria-hidden />
					<span>
						Você está no raio da vaga
						{limiteRaio ? ` (limite ${limiteRaio})` : ""}
					</span>
				</p>
				{distancia ? (
					<p className="gv-fila-raio-ok__dist m-0">{distancia}</p>
				) : null}
			</div>
		)
	}

	return (
		<GestaoVagaCidadeDistancia
			className={className}
			cidadeEstado={cidade}
			distanciaTexto={distancia || (atualizandoGeo ? "Calculando…" : "")}
			onAtualizarLocalizacao={onAtualizarLocalizacao}
			atualizandoLocalizacao={atualizandoGeo || carregando}
		/>
	)
}
